import { useTranslation as useI18n } from 'react-i18next';

export const useTranslation = (ns?: string | string[]) => {
  const { t, i18n } = useI18n(ns);
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage: i18n.language
  };
};
